<div [formGroup]="parentForm" class="location-search">
  <div
    class="flex flex--space-between white-bg rounded-medium border shadow-small"
    matAutocompleteOrigin
    #origin="matAutocompleteOrigin"
  >
    <div [class.relative]="!panelOpen" class="fill">
      <label class="fill grow block">
        <span
          class="absolute nordic-blue-900-text regular-type ps-medium-l ps-xsmall-t font-body-2"
          [ngClass]="{
            'medium-type ps-medium-t font-body-1': !panelOpen && (inputHasValue$ | async) !== true,
          }"
        >
          {{ panelOpen ? panelOpenInputLabel : inputLabel }}
        </span>
        <input
          *ngIf="options$ | async as options; else loading"
          class="nordic-blue-900-text fill no-outline border-none ps-medium-l font-body-1 medium-type grow block ps-medium-t"
          autocomplete="off"
          [id]="controlName"
          [formControlName]="controlName"
          [name]="controlName"
          [matAutocomplete]="auto"
          [matAutocompleteConnectedTo]="origin"
        />
      </label>
    </div>

    <button
      class="ps-medium"
      (click)="dropdownClick($event, panelOpen)"
      [attr.aria-label]="'timetable.aria.search.dropDown' | finLocalization"
      data-testid="location-search-close"
    >
      <fcom-icon
        *ngIf="panelOpen === false"
        class="icon-medium"
        [dataTestId]="'icon-' + SvgLibraryIcon.CHEVRON_DOWN"
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
      ></fcom-icon>
      <fcom-icon
        *ngIf="panelOpen === true"
        class="icon-medium"
        [dataTestId]="'icon-' + SvgLibraryIcon.CLOSE_DELETE"
        [name]="SvgLibraryIcon.CLOSE_DELETE"
      ></fcom-icon>
    </button>
  </div>

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayLocation"
    class="shadow"
    (opened)="this.panelOpen = true"
    (closed)="this.panelOpen = false"
    (optionSelected)="locationSelectionEvent()"
  >
    <mat-option *ngFor="let option of options$ | async" [value]="option">
      <div class="border-bottom flex flex--middle fill">
        <div class="flex flex--column flex--start ms-xsmall-l grow fill">
          <div class="font-body-1 light-type ps-medium-t capitalize">
            {{ option.cityName | finEmpty }} ({{ option.locationCode }})
          </div>
          <div class="font-body-2 light-type ps-medium-b">
            <i class="flag--small flag-{{ option.countryCode }}" aria-hidden="true"></i>{{ option.title }}
          </div>
        </div>
      </div>
    </mat-option>
  </mat-autocomplete>

  <ng-container *ngIf="options$ | async as options">
    <span *ngIf="options.length" class="is-vishidden" aria-live="assertive">
      {{ 'timetable.aria.search.listItems' | finLocalization: { amount: options.length } }}
    </span>
  </ng-container>
</div>

<ng-template #loading>
  <div class="absolute loader pr-xxsmall-y align-center">
    <fin-loader [type]="LoaderType.INLINE_TEXT"></fin-loader>
  </div>
</ng-template>
